// Copyright (c) Move Closer 2023.

import { TopbarConfig } from './TopbarContracts'

export const TOPBAR_COMPONENT_KEY = 'TopbarComponent'

export const TOPBAR_CONFIG_MAP: TopbarConfig = {
  topBarLanguages: []
}
